import { DescriptionOutlinedIcon, NoRowsOverlay } from '@shared/components';

export default function PublishedQSetListNoRowsOverlay() {
  return <NoRowsOverlay title='ยังไม่มีชุดข้อสอบที่เผยแพร่' icon={DescriptionOutlinedIcon} />;
}
